import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoginPage } from '@parrot/auth-ui';

/** Platform SSO API — same as intelligence-platform and parrot-labs. */
const AUTH_BASE = import.meta.env.VITE_AUTH_BASE_URL || 'https://prodapi.parrotanalytics.com';

const NOTICE_MAP: Record<string, string> = {
  password_changed: 'Password updated successfully. Please sign in.',
  session_expired: 'Your session expired. Please sign in again.',
};

export function Login() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const msg = searchParams.get('msg');

  return (
    <LoginPage
      productName={'Streaming Economics'}
      notice={msg ? NOTICE_MAP[msg] : undefined}
      onSubmit={async ({ email, password }) => {
        const res = await fetch(`${AUTH_BASE}/platform/v1/auth/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email, password }),
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.error || 'Invalid credentials');
        }

        // Store platform session token (same key as other products)
        localStorage.setItem('auth_token', data.token);

        // Store user context
        if (data.user) {
          localStorage.setItem('user_email', data.user.email || '');
          localStorage.setItem('user_name', data.user.full_name || '');
          localStorage.setItem('user_role', data.user.role || '');
          localStorage.setItem('account_id', String(data.user.account_id || ''));
        }

        navigate('/');
      }}
      onForgotPassword={() => navigate('/forgot-password')}
    />
  );
}
